import Vue from 'vue';
import Vuex from 'vuex';
import createLogger from 'vuex/dist/logger';
import evaluationStore from '@/ui/store/evaluation';
import paymentsModule from './paymentsModule';
import endorsementModule from './endorsementModule';
import leadsModule from './leadsModule';
import brokersModule from './brokersModule';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    currentUser: JSON.parse(localStorage.getItem('currentUser')),
    backOfficeClientId: JSON.parse(localStorage.getItem('backOfficeClientId')),
    timeAvatar: localStorage.getItem('timeAvatar')
  },
  mutations: {
    SET_CURRENT_USER: (state, value) => {
      state.currentUser = value;
    },
    CLEAR_CURRENT_USER: state => {
      state.currentUser = null;
    },
    SET_CHECK_IN: state => {
      state.currentUser.user.checkIn = { is: true, required: true };
    },
    SET_BACKOFFICE_CLIENT: (state, value) => {
      state.backOfficeClientId = value;
    },
    SET_TIME_AVATAR: (state, value) => {
      state.timeAvatar = value;
    }
  },
  actions: {
    setCurrentUser({ commit }, userObj) {
      localStorage.setItem('currentUser', JSON.stringify(userObj));
      commit('SET_CURRENT_USER', userObj);
    },
    clearCurrentUser({ commit }) {
      localStorage.removeItem('currentUser');
      commit('CLEAR_CURRENT_USER');
    },
    setCheckIn({ commit }, payload) {
      const aux = { ...payload };
      aux.user.checkIn = { is: true, required: true };
      localStorage.setItem('currentUser', JSON.stringify(aux));
      commit('SET_CHECK_IN');
    },
    setbackOfficeClientId({ commit }, userObj) {
      localStorage.setItem('backOfficeClientId', JSON.stringify(userObj));
      commit('SET_BACKOFFICE_CLIENT', userObj);
    },
    setTimeAvatar({ commit }, timeAvatar) {
      localStorage.setItem('timeAvatar', timeAvatar);
      commit('SET_TIME_AVATAR', timeAvatar);
    }
  },
  getters: {
    currentUser: ({ currentUser }) => currentUser,
    timeAvatar: ({ timeAvatar }) => timeAvatar
  },
  modules: {
    brokersModule,
    paymentsModule,
    endorsementModule,
    leadsModule,
    evaluation: evaluationStore
  },
  strict: process.env.NODE_ENV === 'dev',
  plugins: process.env.NODE_ENV === 'dev' ? [createLogger()] : []
});

export default store;
